/**
 * Keys for the CMS assets rendered on the landing / splash pages. Assets are
 * keyed by their Kontent asset name (see `getAllAssetReferences`), so these
 * must match the asset names configured in Kontent. Accessed with optional
 * chaining so a missing asset degrades gracefully rather than throwing.
 */
export const assetNames = {
  logo: 'landing-unum-logo.png',
  desktopScreen: 'landing-screen.png',
  checkmark: 'landing-checkmark.png',
  unumIcon: 'landing-unum-icon.png',
  unumIconWhite: 'landing-unum-icon-white.png',
  informationIcon: 'information-icon.png',
  outage: 'outage.svg',
};
